module.exports = __webpack_public_path__ + "static/media/LBlogo.66123527.svg";